import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXiaomiComponent } from './simple-icons-xiaomi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXiaomiComponent ],
    exports:      [ SimpleIconsXiaomiComponent ],
    bootstrap:    []
})
export class SimpleIconsXiaomiModule {}
